import merge from 'lodash/merge'
import managerResolvers from './manager/resolvers'
import auctionRegistrarResolvers from './registrar/resolvers'
import subDomainRegistrarResolvers from './subDomainRegistrar/resolvers'
import bulkDomainRegistrarResolvers from './bulkRegistrar/resolvers'

export default merge(
  managerResolvers,
  auctionRegistrarResolvers,
  subDomainRegistrarResolvers,
  bulkDomainRegistrarResolvers
)
